import React from "react";
import { FontAwesomeIcon }
    from "@fortawesome/react-fontawesome";
import {
    faUpRightAndDownLeftFromCenter
}
    from "@fortawesome/free-solid-svg-icons";

export default function BlockStackBarList({
    rows,
    onSelect
})
{
	
	const SEGMENT_COLOURS =
	{
	    "A": "#5a9bd6",
	    "B": "#6e78e8",
	    "C": "#a46ce3",
	    "G": "#d66ad0",
	    "P": "#de7595"
	};
	
    if(!rows || rows.length === 0)
    {
        return null;
    }

    let maxValue = 0;

    for(let i = 0; i < rows.length; i++)
    {
        if(rows[i].value > maxValue)
        {
            maxValue =
                rows[i].value;
        }
    }

    return (
        <div
            style={{
                width: "100%"
            }}
        >
            {
                rows.map(
                    function(row)
                    {
                        let widthPercent =
                            row.value /
                            maxValue *
                            100;

                        return (
                            <div
                                key={row.id}
                                style={{
                                    marginBottom: "14px"
                                }}
                            >

                                {/* NAME ROW */}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: "4px",
                                        color: "#ffffff",
                                        fontSize: "12px"
                                    }}
                                >
                                    <span>
                                        {row.name}
                                    </span>

                                    <FontAwesomeIcon
                                        icon={
                                            faUpRightAndDownLeftFromCenter
                                        }
                                        style={{
                                            opacity: 0.6,
                                            cursor: "pointer"
                                        }}
                                        onClick={
                                            function()
                                            {
                                                if(onSelect)
                                                {
                                                    onSelect(
                                                        row.id
                                                    );
                                                }
                                            }
                                        }
                                    />
                                </div>

                                {/* TRACK */}

                                <div
                                    style={{
                                        width: "100%",
                                        height: "10px",
                                        borderRadius: "999px",
                                        overflow: "hidden",
                                        background:
                                            "linear-gradient(180deg,#2f3136,#1a1c20)",
                                        boxShadow:
                                            "inset 0 1px 2px rgba(255,255,255,0.08), inset 0 -1px 2px rgba(0,0,0,0.5)"
                                    }}
                                >

                                    {/* STACK */}

                                    <div
                                        style={{
                                            width:
                                                widthPercent + "%",
                                            height: "100%",
                                            display: "flex"
                                        }}
                                    >

                                        {
                                            row.segments.map(
                                                function(segment, index)
                                                {
                                                    let segmentWidth =
                                                        segment.value /
                                                        row.capacity *
                                                        100;
														
													
														let colour =
														           SEGMENT_COLOURS[
														               segment.label
														           ];

														       if(!colour)
														       {
														           colour =
														               "#5a9bd6";
														       }

                                                    return (
                                                        <div
                                                            key={index}
                                                            title={
                                                                segment.label +
                                                                " : " +
                                                                segment.value
                                                            }
                                                            style={{
                                                                width:
                                                                    segmentWidth + "%",
                                                                height: "100%",
                                                                background:
                                                                    colour
                                                            }}
                                                        />
                                                    );
                                                }
                                            )
                                        }

                                    </div>

                                </div>

                            </div>
                        );
                    }
                )
            }
        </div>
    );
}